<template>
  <div class="flex__column notifications-list">
    <notification-list-item v-for="notification in notifications" :key="notification.id" :notification="notification" @close="$emit('close')"/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { path } from 'ramda'
import NotificationListItem from './NotificationsListItem'

export default {
  name: 'NotificationsList',
  components: { NotificationListItem },
  props: {
    unread: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters(
      {
        unreadNotifications: 'notifications/unreadNotifications',
      },
    ),
    ...mapState(
      {
        allNotifications: path(['notifications', 'entities']),
      },
    ),
    notifications() {
      return this.unread ? this.unreadNotifications : this.allNotifications
    },
  },
}
</script>
